import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { getLanguages, service, translate } from '../services';
import { 
  combineDispatchers, 
  combineStates, 
  configuratorDispatcher,
  messageDispatcher, 
  popupDispatcher,
  siteSettingsState,
  identityState
} from '../store';
import { ConfiguratorPage } from '../site';
import { assignmentDecision, deflateModelVariables, getAssignedValue } from '../util';
class FindConfigurationComponent extends Component {
  constructor() {
    super();
    this.state = {
      isConfigurationReady: false,
      products: null,
      configuration: null
    };
  }
  componentDidMount() {
    let { productId} = this.props;
if(productId.includes('bom') && !productId.includes('supercode')){
  let index1=productId.indexOf('bom=');
  let index2=productId.indexOf('&');
  if(index2>-1){
  productId= productId?.substring(index1+4,index2)
  }
  else{
    productId= productId?.substring(index1+4,productId.length);
  }
        const initialQuantity = 1;
        const arr=productId.split(';')
        const name = arr[0];
        let accessories1=[];
        arr.forEach((item, i) => {
          if (i != 0) {
            let obj = {
              key: '',
              value: item,
            };
            accessories1.push(obj);
          }
        });
        const configuration=[{productName:arr[0],accessories:accessories1}]
     //   const assemblyType = "SelfAssembly";
    return service("getConfiguration")
      .post(configuration)
      .then((response) => {
        const { siteSettings, user } = this.props;
        const lsoCountry =
          siteSettings.properties.LSOCountires &&
          siteSettings.properties.LSOCountires.includes(user.country)
            ? user.country
            : "GL";
        let  product = response.data.configurations.first();
        if(response.data.configurations.length==0){
product=response.data.products.first();
        }
        if (
          lsoCountry &&
          siteSettings.properties.LSOKmats &&
          siteSettings.properties.LSOKmats.includes(
            product.configuration.materialKey
          )
        ) {
          product.configuration.assignments = [
            ...product.configuration.assignments,
            {
              assignmentType: 2,
              isDefault: false,
              key: "LSO",
              value: lsoCountry,
            },
          ];
        }
        product.amount = !product.amount && initialQuantity;
        product.additionalProducts = response.data.configurations.slice(1);
        let title = `${translate("Configure {product}", {
          product: product.code,
        })}`;
        if (product.additionalProducts.length > 0) {
          title = `${translate("Configure {product}", {
            product: product.code,
          })} + ${product.additionalProducts[0].code}`;
        }
        return this.props.setPopup({
          title: title,
          onClose: () =>
            name &&
            setTimeout(() => this.props.removeConfiguration({ name }), 0),
          component: (
            <ConfiguratorPage
              product={product}
              isPopup
            />
          ),
          showHeader: true,
          keepOpen: true,
        });
      })
      .then(() =>
        this.setState({ completed: true, isConfigurationReady: true, name })
      )
      .catch((err) => {
        console.log(err);
        this.props.addMessage({
          timeout: 10000,
          messageType: "error",
          messageText: translate(
            "An error occured during loading the configuration"
          ),
        });
        this.setState({ failed: true, isConfigurationReady: true });
      });
    }
    else if(productId.includes('supercode')){
      let index1= productId.indexOf('supercode=')
      let index2=productId.indexOf('&');
      let superCode=''
      if(index2>-1){
       superCode=productId?.substring(index1+10,index2);
      }
      else{
        superCode=productId?.substring(index1+10,productId.length);
      }
      service( 'materialNames' ).get( ['getConfiguration', superCode] )
        .then( response => {
          const product = response.data;
         // this.setState( { isSearchingSuperCode: false } );
  
          if ( !product ) {
            this.props.addMessage( { timeout: 10000, messageText: translate( 'No results found for {supercode}', { supercode: this.searchInput.value } ), messageType: 'warning' } );
          }
  
          this.props.setPopup(
            {
              title: `${ translate( 'Configure' ) } ${ product.code }`,
              onClose: () => name && setTimeout( () => this.props.removeConfiguration( { name } ), 0 ),
              component: <ConfiguratorPage product={ product } isPopup />,
              showHeader: true,
              keepOpen: true,
            } );
        } )
        .catch( () => {
         // this.setState( { isSearchingSuperCode: false } );
          this.props.addMessage( { timeout: 10000, messageText: translate( 'No results found for {supercode}', { supercode: this.searchInput.value } ), messageType: 'error' } );
        } );
    }
  }
  render() {
    const { isConfigurationReady, failed } = this.state;
    if (!isConfigurationReady) {
      return null;
    }
    const { name } = this.state;
    if( !failed ) {
     // return <Redirect to={ `/configure/${name}` } />;
    }
    const { defaultLandingPage } = this.props;
    return <Redirect to={ defaultLandingPage } />;
  }
}
FindConfigurationComponent.propTypes = {
  defaultLandingPage: PropTypes.string.isRequired
};
export const FindConfiguration = connect( 
  combineStates(identityState,siteSettingsState),
  combineDispatchers( configuratorDispatcher, messageDispatcher, popupDispatcher ) 
)( FindConfigurationComponent );